import { Component, OnInit } from '@angular/core';

/** 企業理念 - 頁面 */
@Component({
    selector: 'app-corporate-philosophy',
    templateUrl: './corporate-philosophy.component.html',
    styleUrls: ['./corporate-philosophy.component.scss'],
})
export class CorporatePhilosophyComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
